import type { AppRole, OrgRole } from '@/services/auth.service';

export interface RoleFlags {
  isOwner: boolean;
  isAdmin: boolean;
  isAtendente: boolean;
  isPrestador: boolean;
}

/**
 * Deriva as flags booleanas de role a partir do role da membership (`role`)
 * e do role do JWT (`orgRole`). owner ⇒ admin; admin/atendente/prestador
 * podem vir de qualquer uma das fontes (lógica OR), preservando o comportamento
 * histórico do useAuth.
 */
export function deriveRoleFlags(role: AppRole | null, orgRole: OrgRole | null): RoleFlags {
  return {
    isOwner: orgRole === 'owner',
    isAdmin: orgRole === 'owner' || orgRole === 'admin' || role === 'admin',
    isAtendente: role === 'atendente' || orgRole === 'atendente',
    isPrestador: role === 'prestador' || orgRole === 'prestador',
  };
}
